module.exports = __webpack_public_path__ + "image/Predator_2.png";